<template>
  <vx-card no-shadow>
    <div class="flex flex-wrap justify-between">
      <p>Add and update expenses categories.</p>
      <div
        class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
        @click="dialog = true"
      >
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Add</span>
      </div>
      <vs-prompt
        @cancel="cancel"
        @accept="accept"
        @close="cancel"
        title="New Expense Type"
        :active.sync="dialog"
        :is-valid="ec != '' && ee != ''"
      >
        <p>
          By creating a new expense type, every expense will be tied to the
          corresponding type.
        </p>
        <br />
        <div v-if="dialog">
          <span class="mt-5 text-sm ml-1"> Expense Category</span>
          <v-select
            class="inputx w-full"
            v-model="ec"
            name="category"
            :options="ec_op"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
          <span class="text-sm ml-1">Required</span>
          <vs-input
            label="Expense Type"
            v-model="ee"
            class="mt-5 w-full"
            name="expense-type"
          />
          <span class="text-sm ml-1">Required</span>
        </div>
      </vs-prompt>
      <vs-prompt
        @cancel="cancel"
        @accept="update"
        @close="cancel"
        title="Update Expense Type"
        :active.sync="udialog"
        :is-valid="isUValid()"
      >
        <br />
        <div v-if="udialog">
          <span class="mt-5 text-sm ml-1"> Expense Category</span>
          <v-select
            class="inputx w-full"
            v-model="uec"
            name="category"
            :options="ec_op"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
          <span class="text-sm ml-1">Required</span>
          <vs-input
            label="Expense Type"
            v-model="uee"
            class="mt-5 w-full"
            name="expense-type"
          />
          <span class="text-sm ml-1">Required</span>
        </div>
      </vs-prompt>
    </div>
    <vs-table :data="et" class="table-dark-inverted">
      <template slot="thead">
        <vs-th>CATEGORY</vs-th>
        <vs-th>TYPE</vs-th>
        <vs-th>ACTION</vs-th>
      </template>

      <template>
        <vs-tr :key="index" v-for="(tr, index) in et">
          <vs-td :data="et[index].a">
            <span class="flex items-center py-1 rounded">{{ tr.a }}</span>
          </vs-td>
          <vs-td :data="et[index].b">
            <span class="flex items-center py-1 rounded">{{ tr.b }}</span>
          </vs-td>
          <vs-td>
            <span class="flex items-center py-1 rounded">
              <feather-icon
                icon="Edit2Icon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current "
                class="ml-2"
                @click.stop="initU(tr)"
              />
              <feather-icon
                icon="XIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current "
                class="ml-2"
                @click="warning(tr)"
              />
            </span>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <!-- Save & Reset Button -->
    <!-- <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2">Save Changes</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning"
        >Reset</vs-button
      >
    </div> -->
  </vx-card>
</template>

<script>
import p from "@/db/pouch";
import vSelect from "vue-select";

export default {
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      udialog: false,
      dialog: false,
      ddr: false,
      et: [],
      ec_op: ["Purchase", "Bills", "Repairs", "Labour", "Misc."],
      ec: "",
      ee: "",
      ueid: "",
      uerev: "",
      uec: "",
      uee: "",
    };
  },
  pouch: {
    etData() {
      return {
        database: process.env.VUE_APP_DB,
        selector: {
          z: 8,
        },
      };
    },
  },
  watch: {
    async etData(d) {
      this.et = await p.de(d);
    },
  },
  computed: {
    ev() {
      return true;
    },
  },
  methods: {
    isValid() {
      return this.ec != "" && this.ee != "";
    },
    isUValid() {
      return this.uec != "" && this.uee != "";
    },
    close() {
      this.ec = "";
      this.ee = "";
      this.uec = "";
      this.uee = "";
      this.dialog = false;
      this.udialog = false;
    },
    cancel() {
      this.close();
    },
    initU(r) {
      this.ueid = r._id;
      this.uerev = r._rev;
      this.uec = r.a;
      this.uee = r.b;
      this.udialog = true;
    },
    async update() {
      var obj = {
        _id: this.ueid,
        _rev: this.uerev,
        a: this.uec,
        b: this.uee,
        c: Date.now(),
        z: 8,
      };
      if (this.isUValid()) {
        await p
          .u(obj)
          .then((r) => {
            if (r.ok) {
              this.$vs.notify({
                title: "Success",
                text: `Successfully Updated Expense Type - ${obj.b}`,
                iconPack: "feather",
                icon: "icon-check-circle",
                color: "success",
              });
            } else {
              throw r.message;
            }
          })
          .catch((e) =>
            this.$vs.notify({
              title: "Error",
              text: `An error occurred: ${e.message || e}`,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
            })
          );
      } else {
        this.$vs.notify({
          title: "Error",
          text: `All fields are required`,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      }
    },
    async accept() {
      if (this.isValid()) {
        const obj = {
          a: this.ec,
          b: this.ee,
          c: Date.now(),
          z: 8,
        };
        this.close();
        await p.c(obj, false).then((ct) => {
          if (ct.ok) {
            this.$vs.notify({
              title: "Success",
              text: `Successfully Saved Expense Type `,
              iconPack: "feather",
              icon: "icon-check-circle",
              color: "success",
            });
          } else {
            this.$vs.notify({
              title: "Error",
              text: `An error occurred: ${ct.message}`,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
            });
          }
        });
      } else {
        this.$vs.notify({
          title: "Error",
          text: `All fields are required`,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      }
    },
    warning(r) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text:
          "Are you sure you want to delete this expense type? This process may be irreversible.",
        accept: () => this.dr(r),
      });
    },
    async dr(rr) {
      await p
        .d(rr)
        .then((r) => {
          if (r.ok) {
            this.$vs.notify({
              title: "Success",
              text: `Successfully Deleted Expense Type - ${rr.b}`,
              iconPack: "feather",
              icon: "icon-check-circle",
              color: "success",
            });
          } else {
            throw r.message;
          }
        })
        .catch((e) =>
          this.$vs.notify({
            title: "Error",
            text: `An error occurred: ${e.message || e}`,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
          })
        );
    },
  },
};
</script>
